// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const SliceOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_4906)"},"children":[{"tag":"path","attrs":{"d":"M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7a2 2 0 00-2 2v14c0 1.1.9 2 2 2h14a2 2 0 002-2V3a2 2 0 00-2-2zm0 16H7V3h14v14z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_4906"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"#fff"}}]}]}]},"name":"slice","theme":"outlined"};

const SliceOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={SliceOutlinedSvg} />;
  SliceOutlined.displayName = 'SliceOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(SliceOutlined);
